<template>
  <v-card v-if="award">
    <v-card-title primary-title>
      <v-layout justify-center>
        <h1 class="headline">{{ award.position }}</h1>
      </v-layout>
    </v-card-title>

    <v-card-text class="pt-0">
      <h1 class="subheading">{{ award.title }}</h1>
      <h1 class="caption">{{ award.date }}</h1>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['award'],
};
</script>
